import PageHeader from "core/components/Header/PageHeader";
import ProductListItem from "core/components/ProductListItem";
import { _t } from "core/language";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { RouterName } from "core/router";
import { getYouTubeThumbnail } from "core/utils/helper";
import RecipeSuggestionItemLoading from "modules/Recipes/components/RecipeSuggestions/Loading";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGetListFavorite, useUpdateFavoriteList } from "../hooks";
import EmptyData from "core/components/EmptyData";
import { useGoToRecipeDetail } from "modules/Recipes/hooks/recipe";
import type { IRecipeDetail } from "modules/Recipes/store/types";
import Icon from "core/assets/icons";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import { useEffect, useState } from "react";
import { useResetRecipe } from "modules/Recipes/hooks/recipe";


const FavoritePage = () => {
  useScrollToTop()
  // const dispatch = useDispatch();
  
  const onResetRecipe = useResetRecipe();
  const goToDetail = useGoToRecipeDetail(RouterName.INGREDIENT_RECIPE_DETAIL);

  const { loading, dataList, loadMore, lastPage, params } = useGetListFavorite()
  const { updateList } = useUpdateFavoriteList()
  const [emptyData, setEmptyData] = useState(false)

  useEffect(() => {
    if(!dataList.length && !loading && params?.page === 1){
      setEmptyData(true)
    }else {
      setEmptyData(false)
    }
  }, [dataList]) 
  useEffect(() => {
    onResetRecipe();
  }, []);
  

  const handleClickNote = (id: number) => {
    return
    updateList(id)
  }

  const handleToDetailRecipe = (data: IRecipeDetail) => {
    // dispatch(updateFavoriteListLocal({dataList:favorites,scrollPosition:window.scrollY}));
    goToDetail(data)
  }

  const handleFetchMore = () => {
    console.log(lastPage,'handleFetchMore',params?.page)
    if(lastPage > params?.page){
      loadMore()
    }
  }
  
  return (
    <AppLayout>
      <PageHeader
        className='fixed  w-full z-[200] bg-white'
        title={_t('favorites.LabelFavorites')}
      />
      <div className="px-4 pt-[43px]" />
      <div className="px-4 mt-[30px]">
        <div className=" rounded-lg ">
          <div className="">


            <InfiniteScroll
              dataLength={dataList.length}
              next={handleFetchMore}
              hasMore={!!dataList.length}
              loader={null}
              className="grid grid-cols-2 gap-x-2 "
            >
              {dataList.map((item: any, key: number) => (<ProductListItem
                handleClick={() => handleToDetailRecipe(item)}
                handleClickNote={handleClickNote}
                showNote
                active={true}
                dataItem={item}
                name={item?.name || ''}
                image={item?.thumbnail || (item?.video_id && getYouTubeThumbnail(item.video_id)) || Icon.NoImage}
                type={1}
                showConfirmRemoveNote
                key={key}
                className='mb-[22px]'
                recipeRequestId={item?.recipe_request_id}
              />))}
            </InfiniteScroll>
                
          </div>
        </div>
        {!dataList.length && loading ? (
           <div className="grid grid-cols-2 gap-2">
            {Array.from(Array(params?.page === 1 ? 10 : 4).keys()).map(
              (e: number) => <RecipeSuggestionItemLoading key={e} />
            )}
          </div>
        ) : 
        (!dataList.length && !loading && emptyData ? <EmptyData message={_t('favorites.LabelYouDontHaveRecipeAddYourFavoriteRecipe')} /> : null)
        }
      </div>
      <BottomNavigation activeIndex={5} />
    </AppLayout>
  );
};

export default FavoritePage;
